export const sectionsI18n = {
  en: {
    content: 'Content',
    confirmMoveLessons: 'You have moved a lesson, it\'s possible that some of the lessons will be re-numbered. Do you still want to move the lesson?',
    fillers: 'Fillers',
    fun: 'Fun',
    deckLibrary: 'Deck\'s Library',
    lessons: 'Lessons',
    additional: 'Additional Content',
    lessonCreator: {
      addLesson: 'Add lesson',
      addToLesson: 'Add lesson to',
      editLesson: 'Edit Lesson',
      convertToLesson: 'Lesson',
      cantConvertForLesson: 'You can\'t convert this folder to a lesson because it contains another lesson. Please remove or move it to another folder to convert it into a lesson',
      cantConvertForFolder: 'You can\'t convert this Lesson to a Folder because it has objects in it. Please remove the objects from this Lesson in order to be able to convert it into a Folder.',
      suggestedTime: 'Suggested Time',
      minutes: 'Minutes',
    },
    move: 'Move',
  },
  es: {
    content: 'Contenido',
    confirmMoveLessons: 'Está moviendo lecciones, es posible que el número de algunas lecciones se reordene. ¿Confirmas el movimiento?',
    fillers: 'Rellenos',
    fun: 'Diversión',
    deckLibrary: 'Libreria de Barajas',
    lessons: 'Lecciones',
    additional: 'Contenido Adicional',
    lessonCreator: {
      addLesson: 'Agregar lección',
      addToLesson: 'Agregar lección a',
      editLesson: 'Editar lección',
      convertToLesson: 'Lección',
      cantConvertForLesson: 'No puedes convertir esta carpeta a lección ya que contiene otras lecciones. Por favor eliminalas o muevelas a otra carpeta para convertirlas a una lección',
      cantConvertForFolder: 'No puede convertir esta lección en una carpeta porque contiene objetos. Elimine los objetos de la lección para poder convertirla en una carpeta.',
      suggestedTime: 'Tiempo Sugerido',
      minutes: 'Minutos',
    },
    move: 'Mover',
  }
};